<template lang="pug">
  // v-if for delay mount tooltip for not confuse hydration
  v-tooltip.BaseTooltipToggle(
    v-if="isMounted",
    v-bind="$attrs",
    ref="tooltip",
    :top="!bottomPosition",
    :bottom="bottomPosition",
    :content-class="`${tooltipClass} ${contentClass} ${disabledClass}`",
    v-model="show",
    :attach="attach",
    :open-on-click="true",
    :open-on-hover="false"
    :class="disabledClass",
    @click="onMouseEnter"
    tag="div",
  )
    template(v-slot:activator="{ on, attrs }")
      span.v-tooltip-activator(
        v-bind="attrs"
        v-on="on"
        ref="activator"
        @click="onMouseEnter"
        :class="disabledClass"
        v-outside-click="{handler: onClickOutside, active: show}"
      )
        slot(name="activator")
      v-btn.hidden-btn(@click="show = !show")
    slot
  span.v-tooltip-activator(
    v-else,
    :class="disabledClass",
  )
    slot(name="activator")
</template>

<script>
import { VTooltip } from 'vuetify/lib';

export default {
  name: 'BaseTooltipToggle',
  components: {
    VTooltip,
  },
  props: {
    contentHeight: {
      type: Number,
      default: 100,
    },
    contentClass: String,
    attach: Boolean,
    disabled: Boolean,
    closeDelay: Number,
  },
  data() {
    return {
      bottomPosition: null,
      visible: false,
      isMounted: false,
      show: false,
    };
  },
  computed: {
    tooltipClass() {
      return this.bottomPosition ? 'tooltip-bottom' : 'tooltip-top';
    },
    disabledClass() {
      if (this.disabled) return 'tooltip-disabled';
      return 'tooltip-enabled';
    },
  },
  mounted() {
    // Do not render tooltip for prerender
    if (this.__prerender) return;
    this.$nextTick(() => {
      this.isMounted = true;
    });
  },
  methods: {
    async onMouseEnter() {
      const activator = this.$refs.activator.getBoundingClientRect();
      this.bottomPosition = activator.top < (this.contentHeight + 80);
      setTimeout(() => {
        const left = activator.left - this.$refs.tooltip.calculatedLeft.replace('px', '');
        const activatorWidth = activator.width / 2;
        const calcLeft = this.bottomPosition ? left + (activatorWidth - 15) : left + activatorWidth;
        this.$emit('left', calcLeft);
      }, 100);
      if (!this.closeDelay) this.visible = true;
    },
    onMouseLeave() {
      if (!this.closeDelay) this.visible = false;
      this.bottomPosition = null;
    },
    onClickOutside() {
      this.show = false;
    },
  },
};
</script>

<style lang="sass">
.v-tooltip
  display: none
.hidden-btn
  display: none
</style>
